import { useState } from "react";
import styled from "styled-components";

function CostumCarousel() {
  const innerLayout = document.querySelectorAll(".innerLayout");
  const [backGroundImage, setBackGroundImage] = useState(
    "../images/travel-concept-with-tickets-paper-plane.jpg"
  );

  const selectBackground = (number) => {
    switch (number) {
      case 1:
        setBackGroundImage(
          "../images/travel-concept-with-tickets-paper-plane.jpg"
        );
        break;
      case 2:
        setBackGroundImage(
          "../images/woman-talking-with-hotel-receptionist-lobby.jpg"
        );
        break;
      case 3:
        setBackGroundImage("../images/BenefitsofOnlinePayments_0721.jpg");
        break;
      default:
        selectBackground("");
    }
  };

  innerLayout.forEach((each) => {
    each.addEventListener("mouseleave", () => {
      each.classList.remove("active");
    });
    each.addEventListener("mouseenter", () => {
      each.classList.add("active");
    });
  });

  return (
    <Main backGroundImage={backGroundImage}>
      <div className="outerLayout">
        <div
          className="innerLayout active"
          onMouseEnter={() => selectBackground(1)}
        >
          <div>
            <h3>تهیه بلیط هواپیما</h3>

            <p dir="auto">
              عازم کجا هستید؟ هیچ فرقی نمی‌کند. این حق شماست که سفری باکیفیت،
              آسان و مطمئن را تجربه کنید. علی‌بابا، به عنوان رتبه یک فروش بلیط
              سفر در کنار شماست تا تجربه‌ای شایسته از یک سفر به‌یادماندنی را
              ایجاد کند. سفر باید آسان باشد، مطمئن و به‌صرفه؛ و همه اینها در علی
              گشت خلاصه شده. از هر کجا به هر کجا، با هواپیما، قطار، اتوبوس یا
              تور.❤
            </p>
            <button>sign up</button>

            <section className="ads">
              <img src="/images/iranair.jpg" alt="" />
              <img src="/images/lufthansa.png" alt="" />
              <img src="/images/emaratair.jpg" alt="" />
              <img src="/images/qatar.jfif" alt="" />
            </section>
          </div>
        </div>
        <div className="innerLayout" onMouseEnter={() => selectBackground(2)}>
          <div>
            <h3>رزرو هتل در سراسر دنیا</h3>

            <p dir="auto">
              فرایند انتخاب و رزرو اینترنتی هتل در علی بابا بسیار ساده است. به
              سادگی و با چند کلیک می توانید با انتخاب مقصد و تاریخ سفر خود، هتل
              مد نظر خود را با قیمت مناسب رزرو کنید. با این حال در صورت نیاز،
              مرکز پشتیبانی علی بابا به صورت 24 ساعته پاسخگوی شماست.
            </p>
            <button>sign up</button>

            <section className="ads">
              <img src="/images/hotellogo.jpg" alt="" />
              <img src="/images/hotellogo2.jpg" alt="" />
              <img src="/images/hotellogo3.jpg" alt="" />
              <img src="/images/hotel4.jpg" alt="" />
            </section>
          </div>
        </div>
        <div className="innerLayout" onMouseEnter={() => selectBackground(3)}>
          <div>
            <h3>پرداخت امن و مطمئن</h3>

            <p dir="auto">
              شما میتوانید با هر نوع کارتی که دارید خرید و رزرو خود را انجام
              دهید، واگر برای رزرو هتل های خارج از کشور اقدام کرده اید نگران
              نبود کارت های اعتباری خارجی نباشید شما می‌توانید هزینه رزرو هتل را
              با همین کارت‌های شتاب خودتان بپردازید.
            </p>
            <button>sign up</button>

            <section className="ads">
              <img src="/images/paypal.png" alt="" />
              <img src="/images/americanexpress.png" alt="" />
              <img src="/images/visa.png" alt="" />
              <img src="/images/mastercard.png" alt="" />
            </section>
          </div>
        </div>
      </div>
    </Main>
  );
}

export default CostumCarousel;

const Main = styled.div`
  max-width: 100vw;
  height: 100vh;
  background-image: url(${(prop) => prop.backGroundImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  transition: all 200ms;
  
  @media (min-width: 600px) and (max-width:900px) {
    height: 100vh;
  }
  @media (max-width: 900px) {
    width: 100vw;
    height: 550px;
  }

  .outerLayout {
    width: 100%;
    height: 100%;
    display: flex;

    .innerLayout {
      width: 33.3333%;
      flex-grow: 1;
      border-right: 0.5px solid white;
      color: #ffff;
      background-color: rgba(0, 0, 0, 0.5);
      transition: all 200ms;
      @media (max-width: 900px) {
        width: 15%;
      }

      &:last-child {
        border-right: none;
      }

      div {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;

        @media (max-width: 900px) {
          max-width: 98%;
          height: 100%;
          overflow-y: hidden;
        }
        p,
        h3,
        button,
        img {
          display: inline-block;
          max-width: 450px;
          visibility: hidden;
        }

        h3 {
          font-size: 32px;
          font-weight: 500;
          color: #ffff;

          @media (max-width: 900px) {
            font-size: 20px;
          }
        }

        p {
          font-size: 18px;
          font-weight: 200;
          line-height: 25px;
          text-align: justify;

          @media (max-width: 900px) {
            font-size: 16px;
          }
        }
        button {
          background-color: #12adeb;
          border: none;
          color: white;
          font-size: 18px;
          padding: 12px 30px;
          border-radius: 2px;
          cursor: pointer;

          &:hover {
            background-color: #0491c9;
          }
        }

        .ads {
          img {
            width: 100px;
            height: 100px;

            @media (max-width: 900px) {
              width: 60px;
              height: 60px;
            }
          }
        }
      }
    }
  }
`;
